import React from 'react';

/**
 * Party Scroll v6 — overlapping avatar row used on cards and activity rows
 * ("Kimmy + 14 friends going", "+ 15 pledged, 3 you know").
 *
 * `people`: array of { name, avatarUrl } — only the first `max` render as
 * circles; the rest are summarized in the trailing `label`.
 */
export default function AvatarStack({
  people = [],
  max = 3,
  size = 24,
  label,
  className = '',
}) {
  const shown = people.slice(0, max);
  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex">
        {shown.map((p, i) => (
          <div
            key={p.id ?? p.userId ?? i}
            className="flex items-center justify-center overflow-hidden rounded-full border-2 border-black bg-white font-mono text-[9px] font-bold uppercase"
            style={{
              width: size,
              height: size,
              marginRight: -7,
              // first avatar inverted for contrast, matching the mockups
              background: i === 0 ? '#000' : '#fff',
              color: i === 0 ? '#fff' : '#000',
            }}
          >
            {p.avatarUrl ? (
              <img src={p.avatarUrl} alt={p.name || ''} className="h-full w-full object-cover" />
            ) : (
              (p.name || '?').charAt(0).toUpperCase()
            )}
          </div>
        ))}
      </div>
      {label && (
        <span className="ml-3 text-[11px] leading-tight text-gray-800">{label}</span>
      )}
    </div>
  );
}
